// removed by extract-text-webpack-plugin
module.exports = {"root":"root___1dFQj","clickable":"clickable___1NNu9","selected":"selected___3ihi-","header":"header___1oxlx","title":"title___Z1ceB","content":"content___33TCA","costs":"costs___T_IwQ","cost":"cost___3OVI9","description":"description___q0AF0"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PricingCard/index.scss
// module id = 101
// module chunks = 0